<template>
  <div
    class="socials gw_box"
    style="--box-padding: 0"
  >
    <div class="gw_box gw_box_widget_title">
      {{ $t('common.follow_us') }}
      <div class="mr-auto"></div>
    </div>
    <div
      class="gw_box d-flex f-wrap"
      :style="`gap: ${socials.length <= 5 ? '0.5rem' : '0.125rem'}; --box-padding: 1rem 0.5rem`"
    >
      <a
        v-for="item in socials"
        :key="item.id"
        :title="item.name"
        class="mdi text-large icon_btn clr-grey pa-2"
        style="--clr-hover: var(--clr-primary)"
        :class="item.icon"
        :href="item.href"
        target="_blank"
      ></a>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'DashboardSocials',
  mixins: [float_mix, format_mix, links_mix],
  data() {
    return {}
  },
  methods: {
    hadleHelpClick(item) {
      if (item.fn) {
        item.fn()
      }
    },
    openRoadmap() {
      this.$store.dispatch('router_set_dialogs', 'roadmap-dialog')
    },
  },
  computed: {
    socials() {
      return [
        {
          hidden: this.$i18n.locale !== 'zh',
          id: 'wechat',
          icon: 'mdi-wechat',
          name: 'WeChat',
          href: 'https://mp.weixin.qq.com/s?__biz=Mzg3NTY3Mzc1Mg==&mid=2247484703&idx=1&sn=befdf39ba20dcabe90078f1665acc3fd&chksm=cf3ca4e8f84b2dfe726b9a94261af0dd49231d589750ab4e8868e900d436a06ce2eda0842e20&token=40996548&lang=zh_CN#rd',
        },
        {
          hidden: this.$i18n.locale !== 'zh',
          id: 'bilibili',
          icon: 'gw-icon-bilibili ',
          name: 'Bilibili',
          href: 'https://space.bilibili.com/1776741195',
        },
        {
          id: 'facebook',
          icon: 'mdi-facebook',
          name: 'Facebook',
          href: 'https://www.facebook.com/GTOWizard/',
        },
        {
          id: 'instagram',
          icon: 'mdi-instagram',
          name: 'Instagram',
          href: 'https://www.instagram.com/gtowizard/',
        },
        {
          id: 'twitter',
          icon: 'mdi-twitter',
          name: 'Twitter',
          href: 'https://twitter.com/gtowizard',
        },
        {
          hidden: this.$i18n.g1,
          id: 'youtube',
          icon: 'mdi-youtube',
          name: 'Youtube',
          href: 'https://www.youtube.com/@GTOWizard',
        },
        {
          hidden: this.$i18n.g1,
          id: 'twitch',
          icon: 'mdi-twitch',
          name: 'Twitch',
          href: 'https://www.twitch.tv/gtowizardtv',
        },
        {
          id: 'discord',
          icon: 'mdi-discord',
          name: 'Discord',
          href: this.links_url_links.discord_invite_link.url,
        },
      ].filter(i => !i.hidden)
    },
  },
}
</script>
<style lang="scss" scoped>
// .gw-icon-bilibili {
//   &::before {
//     transform: scale(0.85);
//   }
// }
.help-actions {
  display: flex;
  flex-direction: column;
  min-width: 12rem;
  // gap: 0.5rem;
  &_action {
    color: var(--clr-grey-2);
    font-size: 1rem;
    padding: 0.5rem 0.75rem;
    display: flex;
    align-items: center;
    // justify-content: center;
    cursor: pointer;
    transition: 0.2s;
    background: transparent;
    border-radius: 8px;
    &:hover {
      background: var(--clr-black-1);
    }
  }
}
</style>
